import { useScreenSize } from "@/hooks/use-screen-size"

export const TailwindSize = () => {
  const screenSize = useScreenSize()
  if (process.env.NODE_ENV === "production") {
    return null
  }
  let minWidth = ""
  switch (true) {
    case screenSize.width > 1536:
      minWidth = "2xl"
      break
    case screenSize.width > 1280:
      minWidth = "xl"
      break
    case screenSize.width > 1024:
      minWidth = "lg"
      break
    case screenSize.width > 768:
      minWidth = "md"
      break
    case screenSize.width > 640:
      minWidth = "sm"
      break
    default:
      minWidth = "<"
      break
  }
  return (
    <div className="text-t100 fixed bottom-0 left-0 z-50 flex h-[18px] w-[24px] items-center justify-center bg-black pb-[2px] text-[12px] leading-[16px]">
      {minWidth}
    </div>
  )
}
